export const AppSettings = {
    appName: "DAO Graph",
    appIcon: "",

    apiKey_theGraph: "23b6fc3e2f8313a2ee6c04b4d443d3da"
}